// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import useDataTransform from './useDataTransform'
import useDataOnChange from './useDataOnChange'
import useDataOnSubmit from './useDataOnSubmit'
import rdata from './data.json'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function PaymentProviderData(props) {
  let data = useDataTransform(props, rdata.value)
  let onChange = useDataOnChange(props, data)
  let onSubmit = useDataOnSubmit(props, data)

  return (
    <DataProvider
      context="payment"
      value={data}
      viewPath={props.viewPath}
      onChange={onChange}
      onSubmit={onSubmit}
    >
      <View {...props} />
    </DataProvider>
  )
}